import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'sonner';
import { Loader2, CheckCircle2, AlertTriangle } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function VerifyEmailPage() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const token = params.get('token');
  const [state, setState] = useState('loading');
  const [error, setError] = useState('');

  useEffect(() => {
    if (!token) {
      setState('error');
      setError('Missing verification token.');
      return;
    }
    axios.post(`${API_URL}/api/auth/verify-email`, { token })
      .then(() => {
        setState('ok');
        toast.success('Email verified - thanks!');
        setTimeout(() => navigate('/'), 1500);
      })
      .catch((err) => {
        setState('error');
        setError(err.response?.data?.detail || 'Could not verify your email.');
      });
  }, [token, navigate]);

  return (
    <div className="min-h-screen bg-[#FAFAFA] flex items-center justify-center p-6" data-testid="verify-email-page">
      <div className="bg-white border border-[#E2E8F0] rounded-2xl shadow-sm max-w-md w-full p-8 text-center">
        {state === 'loading' && (
          <>
            <Loader2 size={32} className="animate-spin mx-auto mb-3 text-[#1D4ED8]" />
            <p className="text-sm text-[#475569]">Verifying your email…</p>
          </>
        )}
        {state === 'ok' && (
          <>
            <CheckCircle2 size={36} className="mx-auto mb-3 text-emerald-600" />
            <h1 className="text-xl font-bold text-[#0A0F1C] mb-2" data-testid="verify-email-success">Email verified!</h1>
            <p className="text-sm text-[#475569]">Redirecting you to the home page…</p>
          </>
        )}
        {state === 'error' && (
          <>
            <AlertTriangle size={36} className="mx-auto mb-3 text-amber-500" />
            <h1 className="text-xl font-bold text-[#0A0F1C] mb-2" data-testid="verify-email-error">Verification failed</h1>
            <p className="text-sm text-[#475569] mb-4">{error}</p>
            <button onClick={() => navigate('/portal/settings')} className="text-sm font-bold text-[#1D4ED8] hover:underline">Request a new link from Settings →</button>
          </>
        )}
      </div>
    </div>
  );
}
